// Set the default locale as a constant variable
export const getDefaultLocale = () => {
  // 1. Check URL path for language prefix (e.g., /en/, /fr/)
  const pathLang = window.location.pathname.split('/')[1];
  if (['en', 'fr'].includes(pathLang)) {
    localStorage.setItem('locale', pathLang);
    return pathLang;
  }

  // 2. Check ?lang query param in the URL
  const urlLang = new URLSearchParams(window.location.search).get('lang');
  if (urlLang && ['en', 'fr'].includes(urlLang)) {
    localStorage.setItem('locale', urlLang); // Store it for next loads
    return urlLang;
  }

  // 3. Check localStorage
  const storedLocale = localStorage.getItem('locale');
  if (storedLocale && ['en', 'fr'].includes(storedLocale)) {
    return storedLocale;
  }

  // 4. Fallback to browser language
  const browserLocale = navigator.language || navigator.userLanguage || 'en';
  const locale = browserLocale.split('-')[0];
  return ['en', 'fr'].includes(locale) ? locale : 'en';
};

// Utility function to get language from current route
export const getLanguageFromRoute = (route) => {
  if (route && route.meta && route.meta.language) {
    return route.meta.language;
  }
  
  const pathLang = route?.path?.split('/')[1];
  if (['en', 'fr'].includes(pathLang)) {
    return pathLang;
  }
  
  return null;
};

// Utility function to create localized route
export const createLocalizedRoute = (routeName, params = {}, language = null) => {
  const currentLang = language || localStorage.getItem('locale') || 'en';
  
  // If no language specified or it's the default, return original route
  if (!language) {
    return { name: routeName, params };
  }
  
  // Return localized route with explicit name
  const localizedRouteName = `${routeName}${currentLang.charAt(0).toUpperCase() + currentLang.slice(1)}`;
  return { name: localizedRouteName, params };
};

const state = {
  locale: getDefaultLocale(), // Retrieve from local storage or use the default locale
};

const mutations = {
  SET_LOCALE(state, locale) {
    if (['en', 'fr'].includes(locale)) {
      state.locale = locale;
      localStorage.setItem('locale', locale); // Store locale in local storage
    }
  },
};

const actions = {
  setLocale({ commit }, locale) {
    commit('SET_LOCALE', locale);
  },
  
  // Action to switch language and optionally redirect
  async switchLanguage({ commit }, { locale, redirect = true }) {
    commit('SET_LOCALE', locale);
    
    if (redirect && window.location.pathname !== '/') {
      // Get current route info
      const currentPath = window.location.pathname;
      const pathParts = currentPath.split('/');
      
      // If current path has a language prefix, replace it
      if (['en', 'fr'].includes(pathParts[1])) {
        pathParts[1] = locale;
        const newPath = pathParts.join('/');
        window.location.pathname = newPath;
      } else {
        // Add language prefix to current path
        const newPath = `/${locale}${currentPath}`;
        window.location.pathname = newPath;
      }
    }
  },
};

const getters = {
  locale: (state) => state.locale,
  isEnglish: (state) => state.locale === 'en',
  isFrench: (state) => state.locale === 'fr',
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};